import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../API/axiosInstance";
import { FaShoppingCart, FaMapMarkerAlt } from "react-icons/fa";
import "./serviceDetails.css";
import { Modal, Button } from "react-bootstrap";
import useAuthCheck from "../../Auth/useAuthCheck";


export default function ServiceDetails() {
  const { service_id } = useParams();
  const [token, setToken] = useState(null);
  const [serviceDetails, setServiceDetails] = useState(null);
  const [mainImage, setMainImage] = useState("");
  const [showConflict, setShowConflict] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useAuthCheck()
  // get token from localStorage
  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
    }


    const storedUser = localStorage.getItem("currentUser");
    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser));
    }
  }, []);

  // fetch service details
  useEffect(() => {
    const loadServiceDetails = async () => {
      if (!token || !service_id) return;

      try {
        const response = await axiosInstance.get(`/service/${service_id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setServiceDetails(response.data);
        if (response.data.images && response.data.images.length > 0) {
          setMainImage(response.data.images[0]);
        }
      } catch (error) {
        console.error("Error fetching service:", error);
      }
    };

    loadServiceDetails();
  }, [token, service_id]);

  const handleAddToCart = async () => {
    if (!serviceDetails || !token) return;

    try {
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      if (!userData) {
        alert("Please login first!");
        return;
      }

      const payload = {
        serviceId: serviceDetails.id,
        serviceName: serviceDetails.service_name,
        price: serviceDetails.max_price,
        quantity: 1,
        vendorId: serviceDetails.vendor_id,
      };

      const response = await axiosInstance.post(
        `/cart/${userData.id}/addItem`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        alert("Item added to cart ");
      } else if (response.status === 409) {
        // alert("This service is already in your cart!");
        setShowConflict(true);

      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      alert("Something went wrong while adding to cart ");
    }
  };

  if (!serviceDetails) return <p className="text-center py-5">Loading...</p>;

  return (
    <div className="container my-5">
      {/* Page Title */}
      <div className="text-center m-0">
        <h3 className="fw-bold text-dark">Service Details</h3>
        <p className="text-muted">
          Explore complete information about this service below
        </p>
      </div>

      <div className="row g-4 shadow p-4 rounded bg-white" style={{ height: "max-content" }}>
        {/* Left Side - Image Gallery */}
        <div className="col-md-6">
          <div className="mb-3">
            <img
              src={mainImage || "/placeholder.jpg"}
              alt="Service"
              className="img-fluid rounded shadow-sm w-100"
              style={{ height: "380px", objectFit: "cover" }}
            />
          </div>

          {/* Thumbnails */}
          <div className="d-flex flex-wrap gap-2">
            {serviceDetails.images?.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt="thumb"
                onClick={() => setMainImage(img)}
                className="rounded border"
                style={{
                  width: "90px",
                  height: "70px",
                  objectFit: "cover",
                  cursor: "pointer",
                }}
              />
            ))}
          </div>
        </div>

        {/* Right Side - Details */}
        <div className="col-md-6 d-flex flex-column">
          <div>
            <h2 className="fw-bold">{serviceDetails.service_name}</h2>
            <p className="text-muted">{serviceDetails.description}</p>

            {/* Location */}
            <p className="mt-3 mb-2">
              <FaMapMarkerAlt className="me-2 text-danger" />
              <strong>Location:</strong> {serviceDetails.location}
            </p>

            {/* Prices */}
            <div className="d-flex gap-4 mt-3">
              <div>
                <h5 className="fw-bold text-success">₹{serviceDetails.min_price}</h5>
                <p className="text-muted small mb-0">Minimum Price</p>
              </div>
              <div>
                <h5 className="fw-bold text-success">₹{serviceDetails.max_price}</h5>
                <p className="text-muted small mb-0">Maximum Price</p>
              </div>
            </div>
          </div>

          {/* Add to Cart */}
          { currentUser.role == "USER" && 
          <>
            <div className="mt-4">
              <button
                onClick={handleAddToCart}
                className="btn btn-warning btn-lg w-100 fw-bold"
              >
                <FaShoppingCart className="me-2" /> Add to Mind
              </button>
            </div>
          </>}
        </div>
      </div>

      {/* Conflict Dialog */}
      <Modal show={showConflict} onHide={() => setShowConflict(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Cart Alert!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your cart already contains services from another vendor. "
          "Do you want to discard them and add services from this vendor?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConflict(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              // you can call increaseQuantity() here
              setShowConflict(false);
            }}
          >
            Increase Quantity
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
